import Urls from '../../definitions/Urls';
import services from '../../components/service/Services';

const createActionName = require('../util').createActionName('questionnaires');

export const REQUEST_ASSIGNED_FORMS = createActionName(
  'REQUEST_ASSIGNED_FORMS'
);
export const REQUEST_ALL_COMPLETED_AIVA_PROCESSES = createActionName(
  'REQUEST_ALL_COMPLETED_AIVA_PROCESSES'
);
export const RECEIVE_ALL_COMPLETED_AIVA_PROCESSES = createActionName(
  'RECEIVE_ALL_COMPLETED_AIVA_PROCESSES'
);
export const REQUEST_ALL_COMPLETED_AIVA_PROCESSES_FAILED = createActionName(
  'REQUEST_COMPLETED_AIVA_PROCESS_FAILED'
);
export const REQUEST_AIVA_PROCESS = createActionName('REQUEST_AIVA_PROCESS');
export const RECEIVE_AIVA_PROCESS = createActionName('RECEIVE_AIVA_PROCESS');
export const RECEIVE_ASSIGNED_FORMS = createActionName(
  'RECEIVE_ASSIGNED_FORMS'
);
export const REQUEST_ASSIGNED_FORMS_FAILED = createActionName(
  'REQUEST_ASSIGNED_FORMS_FAILED'
);

export const REQUEST_QUESTIONNAIRES = createActionName(
  'REQUEST_QUESTIONNAIRES'
);
export const RECEIVE_QUESTIONNAIRES = createActionName(
  'RECEIVE_QUESTIONNAIRES'
);
export const REQUEST_QUESTIONNAIRES_FAILED = createActionName(
  'REQUEST_QUESTIONNAIRES_FAILED'
);
export const SHOW_OMAVOINTI_QUESTIONNAIRE_MODAL = createActionName(
  'SHOW_OMAVOINTI_QUESTIONNAIRE_MODAL'
);
export const HIDE_OMAVOINTI_QUESTIONNAIRE_MODAL = createActionName(
  'HIDE_OMAVOINTI_QUESTIONNAIRE_MODAL'
);
export const SET_MOBILE_CLIENT_STATE = createActionName(
  'SET_MOBILE_CLIENT_STATE'
);
export const REQUEST_FORM_DATA = createActionName('REQUEST_FORM_DATA');
export const RECEIVE_FORM_DATA = createActionName('RECEIVE_FORM_DATA');
export const REQUEST_FORM_DATA_FAILED = createActionName(
  'REQUEST_FORM_DATA_FAILED'
);

export const requestAssignedForms = () => ({
  type: REQUEST_ASSIGNED_FORMS,
});

export const receiveAllCompletedAivaProcesses = (data) => ({
  type: RECEIVE_ALL_COMPLETED_AIVA_PROCESSES,
  data,
});

export const requestAllCompletedAivaProcesses = () => ({
  type: REQUEST_ALL_COMPLETED_AIVA_PROCESSES,
});
export const requestAivaProcess = () => ({
  type: REQUEST_AIVA_PROCESS,
});
export const receiveAivaProcess = (data) => ({
  type: RECEIVE_AIVA_PROCESS,
  data,
});
export const receiveAssignedForms = (data) => ({
  type: RECEIVE_ASSIGNED_FORMS,
  data,
});

export const requestAssignedFormsFailed = (error) => ({
  type: REQUEST_ASSIGNED_FORMS_FAILED,
  error,
});

export const requestFormData = () => ({
  type: REQUEST_FORM_DATA,
});
export const receiveFormData = (data) => ({
  type: RECEIVE_FORM_DATA,
  data,
});
export const requestFormDataFailed = (error) => ({
  type: REQUEST_FORM_DATA_FAILED,
  error,
});

export const requestAllCompletedAivaProcessesFailed = (error) => ({
  type: REQUEST_ALL_COMPLETED_AIVA_PROCESSES_FAILED,
  error,
});

export const requestQuestionnaires = () => ({
  type: REQUEST_QUESTIONNAIRES,
});

export const setMobileClientState = (mobileClientState) => ({
  type: SET_MOBILE_CLIENT_STATE,
  payload: { mobileClientState },
});

export const receiveQuestionnaires = (data) => ({
  type: RECEIVE_QUESTIONNAIRES,
  data: data,
});

export const requestQuestionnairesFailed = (error) => ({
  type: REQUEST_QUESTIONNAIRES_FAILED,
  error: error,
});

export const showOmavointiQuestionnaireModal = (formCode, formId) => ({
  type: SHOW_OMAVOINTI_QUESTIONNAIRE_MODAL,
  formCode,
  formId,
});

export const hideOmavointiQuestionnaireModal = () => ({
  type: HIDE_OMAVOINTI_QUESTIONNAIRE_MODAL,
});

export const receivedQuestionnaires = (data) => (dispatch) => {
  dispatch(receiveQuestionnaires(data));
};

export const fetchAssignedForms = () => (dispatch, _, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestAssignedForms());
    services.api
      .getAssignedForms()
      .then((data) => {
        resolve(dispatch(receiveAssignedForms(data)));
      })
      .catch((error) => {
        reject(dispatch(requestAssignedFormsFailed(error)));
      });
  });
};

export const fetchAllCompletedAivaProcesses = () => (dispatch, _, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestAllCompletedAivaProcesses());
    services.api
      .getAllCompletedAivaProcesses()
      .then((data) => {
        resolve(dispatch(receiveAllCompletedAivaProcesses(data)));
      })
      .catch((error) => {});
  });
};

export const fetchAivaProcess = (aivaProcessId) => (dispatch, _, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestAivaProcess());
    services.api
      .getAivaProcess({ aivaProcessId })
      .then((data) => {
        resolve(dispatch(receiveAivaProcess(data)));
      })
      .catch((error) => {});
  });
};

export const getQuestionnaires = () => (dispatch, _, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestQuestionnaires());
    services.api
      .getQuestionnaires()
      .then((data) => {
        resolve(dispatch(receivedQuestionnaires(data)));
      })
      .catch((error) => {
        reject(dispatch(requestQuestionnairesFailed(error)));
      });
  });
};

export const getFormData = (id) => (dispatch, _, services) => {
  return new Promise((resolve, reject) => {
    dispatch(requestFormData());
    services.api
      .getFormData({ id })
      .then((data) => {
        resolve(dispatch(receiveFormData(data)));
      })
      .catch((error) => {
        reject(dispatch(requestFormDataFailed(error)));
      });
  });
};

const createOmavointiLink = (token, formId) => {
  return (
    `${Urls.omavointiRedirectUrl()}?token=${token}` +
    (formId === null || formId === undefined ? '' : `&formId=${formId}`)
  );
};

export const goToOmavointi =
  (newWindow, formCode, formId) => (dispatch, getState, services) => {
    let content = newWindow.document.createElement('p');
    content.innerHTML = 'Uudelleenohjataan, odota hetki...';
    newWindow.document.body.appendChild(content);
    return services.api
      .omavointiRedirect({ payload: formCode })
      .then((data) => {
        dispatch(hideOmavointiQuestionnaireModal());
        return createOmavointiLink(data, formId);
      })
      .then((url) => {
        newWindow.location.href = url;
      })
      .catch((err) => {
        content.innerHTML =
          'Kyselyyn ohjauksessa tapahtui virhe. Voit sulkea tämän välilehden.';
        //newWindow.document.write('Kyselyyn ohjauksessa tapahtui virhe. Voit sulkea tämän välilehden.')
      });
  };

export const cookieChecker = () => (dispatch) => {
  /* test values
    document.cookie = "mobileCookieAndroid=testcookie1";
    document.cookie = "mobileCookieIos=testcookie2";
    */

  if (
    document.cookie.includes('mobileCookieAndroid') ||
    document.cookie.includes('mobileCookieIos')
  ) {
    dispatch(setMobileClientState(true));
  } else {
    dispatch(setMobileClientState(false));
  }
};
